<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-lg-4"> <!--left section-->
                            <div class="row">
                                <div class="header-section col-12 float-l bgcolor-cfe3ee"> <!--header section-->
                                    <div class="back-btn-chat float-l">
                                        <a href="javascript:void(0)" v-on:click="backChatList()"> <i class="hi-icon icon-chatback"></i> </a>
                                    </div>

                                    <div class="customer-name float-l colpie-87">
                                        <p class="user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"> {{email | filtersGetName(name)}} </p>
                                        <p class="color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_1 pl_90 mb_0"> {{name}} 
                                            <span class="color-58595b font-benton-medium heading-text-11 line-height-15 float-l width-full pt_2"> {{sections}} ({{role}}) </span>
                                        </p>
                                    </div>

                                    <ul class="dropdown-menu-profile middle-chat-query-section">
                                        <li> <p> <span> <i class="fa fa-envelope-o"></i> </span>  user@gmail.com </p> </li>
                                        <li> <p class="phone-number-sec"> <span> <i class="fa fa-phone"></i> </span>  1234567890 </p> </li>
                                        <li class="query-message"> <p class="query-section"> <span> <i style="font-weight:bold;" class='hi-icon icon-chatoval-speech-bubble'></i> </span> Testing message subject </p></li>
                                    </ul>

                                    <div class="menu-right-header float-r" v-if="role == 'guest' || role == 'Guest'"> <!--header menu section-->
                                        <div class="nc-chat-right-dropdown">
                                            <div class="dropdown">

                                                <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                </button>

                                                <ul class="dropdown-menu">
                                                    <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal1"> Email Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                    <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal"> Forward Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                    <li> <a href="javascript:void(0)" v-on:click="sendMessage('EndChat')"> End Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> <!--header menu section-->
                                </div> <!--header section-->

                                <div class="chat-btm-section-main chat-listing-main-mobile width-full float-l message-height">
                                    <div class="chat-detail-main col-12 float-l">
                                        <template v-if="messageArray && messageArray.length > 0" v-for="(message, index) in messageArray" >
                                            <div class="user-chat-main colpie-85 float-l" v-if="message.fromId != logingId"> <!--user chat-->
                                                <div class="user-img float-l">
                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">
                                                        {{email | filtersGetName(name)}}
                                                    </span>
                                                    <!--<img src="/static/images/user-img.jpg" alt="User Name">-->
                                                </div>

                                                <div class="user-massage float-l width-full">
                                                    <p class="message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0"> {{message.message}} </p>
                                                    <p class="date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12"> {{message.created_date | filterDate}} </p>
                                                </div>
                                            </div> <!--user chat-->

                                            <div class="admin-chat-main colpie-82 float-r" v-else> <!--admin chat-->
                                                <div class="user-massage float-r width-full">
                                                <p class="message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0"> {{message.message}} </p>
                                                <p class="date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12"> {{message.created_date | filterDate}} </p>
                                                </div>
                                            </div> <!--admin chat-->
                                        </template>
                                        <div class="message-typing float-r width-full" v-if="isHideType">
                                            <div class="admin-typing colpie-82 float-l">
                                                <div class="tiblock float-l">
                                                    <div class="tidot"></div>
                                                    <div class="tidot"></div>
                                                    <div class="tidot"></div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="btm-chat-textarea float-l col-12">
                                    <!-- Old code that shows the message field error on blank message send button  click
                                        <!--<textarea id="msgTextArear" v-validate="'required'" @input="typingEvent()" v-model="messageData" type="text" placeholder="Type your message here..." required="required" class="form-control" name="message"></textarea>
                                        &lt;!&ndash; <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span> &ndash;&gt;
                                        <div class="help is-danger">{{message_text_error_msg}}</div>-->

                                    <textarea id="msgTextArear" @input="typingEvent()" v-model="messageData" type="text" placeholder="Type your message here..." class="form-control" name="message"></textarea>

                                    <div class="send-message-btn float-l">
                                        <a href="javascript:void(0)" v-on:click="sendMessage('Chat')"> <i class="hi-icon icon-chatplay-button"></i> </a>
                                    </div>
                                </div> 
                            </div>
                        </div> <!--left section-->
                    </div>

                    <div class="modal fade forward-chat-modal" id="basicModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true"> <!--forward modal popup--> 

                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="myModalLabel">Forward Message To</h4>
                                    <div class="nc-search">
                                        <div class="input-group stylish-input-group">
                                            <input type="text" class="form-control fName" @input="searchAPI('forwardChat')" v-model="searchText" placeholder="Search" id="forName">
                                            <span class="input-group-addon">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="modal-body forward-chat-main float-l width-full p_0" v-if="userArray && userArray.length > 0">
                                    <template v-for="(user, index) in userArray">
                                        <div :key="index" class="chat-listing-section-main chat-forward-section pull-left width-full border-none">
                                            <div class="pull-left width-full p-15 relative">                        
                                                <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"> {{user.email | filtersGetName(user.name)}}
                                                    <span class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                </span>

                                                <div class="right-listing-detail pl_65 pull-left width-full pr_35 custom-checkbox">                         
                                                    <h3 class="color-333333 font-benton-bold heading-text-15 line-height-19 float-l width-full mb_3"> {{user.roleName | filterCamelCase}}({{user.email}})</h3>
                                                    <span class="color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{user.sections | filterCamelCase}} </span>
                                                    
                                                    <div class="radiobutton">
                                                        <label class="custom-radio-container">
                                                            <!-- <input type="radio" name="chat" value="nadmin name">  -->
                                                            <input v-model="radioBtnId" type="radio" name="chat" :value="user.id"> 
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                                <div class="chat-forward-btm float-l width-full bgcolor-eff1f1 relative">   
                                    <!-- :id="chatWindow.senderid" :data-userName="chatWindow.name" v-on:click="forwardMessage"                              -->
                                    <a class="nc-forward-chat-send" href="javascript:void(0);" v-on:click="forwardMessage()">
                                        <i class="hi-icon icon-chatright-arrow"></i> <br/>
                                        <span>Forward</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div> <!--forward modal popup--> 

                    <div class="modal fade forward-chat-modal email-chat-modal" id="basicModal1" tabindex="-1" role="dialog" aria-labelledby="basicModal1" aria-hidden="true"> <!--Email chat modal popup--> 

                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="myModalLabel">Email Chat To</h4>
                                </div>

                                <div class="modal-body email-chat-main float-l width-full p_0">
                                    <div class="form-group float-l width-full p_15">
                                        <input v-validate="'required|email'" type="email" name="email" v-model="emailChat" placeholder="Your email address here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email address here'" class="form-control custom-select">
                                        <div class="help is-danger">{{emailChat_error_msg}}</div>
                                    </div>
                                </div>

                                <div class="chat-forward-btm float-l width-full bgcolor-eff1f1 relative">
                                    <a class="nc-forward-chat-send" href="javascript:void(0);" v-on:click.prevent="sendChatEmail()">
                                        <i class="hi-icon icon-chatright-arrow"></i> <br/>
                                        <span>Send</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div> <!--Email chat modal popup-->
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    // import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';

    // Vue.component("app-footer", Footer);
    export default {
        name: 'ChatDetail',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                userDetails: [],
                logingId: 0,
                userName: '',
                messageArray: [],
                name: '',
                email: '',
                sections: '',
                role: '',
                messageData: '',
                isHideType: false,
                pusher: '',
                message_text_error_msg: '',
                typeAPICallFlag: true,
                searchText: '',
                userArray: [],
                customerArray: [],
                radioBtnId: 0,
                emailChat: '',
                emailChat_error_msg: '',
                sendFromThisSide : false,
                lastMessage: "",
                uuid : "",
            }
        },
        created() {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            self.status = localStorage.getItem('status');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                self.userName = userJson['name'];
                self.timezone = userJson["timezone"];
            }
            self.channel = self.$pusher.subscribe('private-chat');
            /*self.channel.bind('client-send-typing-event'+ self.toId + self.logingId, function(data) {
                self.isHideType = true;
                setTimeout(function() {
                    self.isHideType = false;
                }, 3000);
            });*/
        },
        mounted: function() {
            var self = this;
            /* self.pusher = new Pusher('48e44077269fc26fa1d6', {
                cluster: 'mt1',
            }); */

            self.pusher = self.$pusher;

            $(document).on('keypress',function(e) {
                if(e.which == 13) {
                    e.preventDefault();
                    self.sendMessage('Chat');
                    // $('#sendMessage').click();\
                }
            });
        
            var userObj = localStorage.getItem('user_obj');
            // self.status = localStorage.getItem('status');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                
                self.userName = userJson['name'];
            }

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3] > 0) {
                self.getMessageHistoryData(segments[3]);
                self.loadCustomerDetails(segments[3]);
                self.toId = segments[3];

                self.channel.bind('client-send-typing-event'+ self.toId + self.logingId, function(data) {
                    self.isHideType = true;
                    setTimeout(function() {
                        self.isHideType = false;
                    }, 3000);
                });
            }
            
            self.loadUser();
            self.broadCastChatDetails();
            self.broadCastTypeMessageChatDetails();
            self.broadCastForwardChat();
        },

        filters: {
            filtersGetName(value, value2) {

                let name1 = value2.split(" ");
                if(name1[1] && name1[1] != '') {
                    let getName = name1[0].charAt(0) + name1[1].charAt(0);
                    return getName.toUpperCase();
                } else {
                    if (value) {
                        let name = value.charAt(0);
                        let splitData = value.split("@");
                        name += splitData[1].charAt(0);
                        return name.toUpperCase();
                    }
                }
            },
            filterCamelCase(data) {

                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }, 
            filterDate(date) {
                if (date) {
                    var splitDate = date.split(", ");
                    return splitDate[1];
                } else {
                    return '';
                }
            }
        },
        methods: {
            trigger(eventName, message) {
                var self = this;
                setTimeout(function() {
                  if ((self.messageData.length - self.lastMessage.length) > 5) {
                    self.lastMessage = self.messageData;
                    self.channel.trigger(eventName, { message });
                  }
                }, 1000);
            },
            typingEvent() {
                var self = this;
                self.trigger('client-send-typing-event'+ self.logingId + self.toId, 'Type!');
            },
            backChatList: function() {
                var self = this;
                self.$router.push("/chat/list");
            },
            loadUser: function() {
                var self = this;

                var fields = {
                    isUserList: 'chatUser',
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post("list-user", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if (response.data.content != "") {
                                    self.userArray = response.data.content;
                                }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });
            },

            broadCastForwardChat: function() {

                var self = this;
                var pusherKey = 'forward-customer-broadcast-channle' + self.logingId;
                var eventKey = 'forward-customer-broadcast-event' + self.logingId;

                let fromName, fromId, message;
                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {
                    fromId = data.fromId;
                    fromName = data.fromName;
                    message = data.message;
                    let messageData = {"fromName" : fromName , "fromId" : fromId, "message" : message};
                    self.$nextTick(() => {
                        self.listenNotification(messageData);
                    });
                });
            },

            sendChatEmail: function() {
                
                var self = this;
                var error = false;
                self.emailChat_error_msg = "";
                var path = window.location.pathname;
                var segments = path.split("/");
                if(self.emailChat == '' || self.emailChat == null) {
                    self.emailChat_error_msg = "Email Field is Required.";
                    error = true;
                }

                if (self.emailChat && !self.validEmail(self.emailChat)) {
                    self.emailChat_error_msg = "Enter Valid Email.";
                    error = true;
                }

                if (!error) {

                    var fields = {
                        via: 'email',
                        email: self.emailChat,
                        chatOf: segments[3],
                        fromName: self.userName,
                        forwardTo: '',
                        section: self.sections,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    //self.showLoader();
                    HTTP.post("forward-to-user", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    //console.log($('#basicModal1')[0]);
                                    $('#basicModal1')[0].hidden = true;
                                    $('.modal-backdrop').remove();
                                }
                                //self.hideLoader();
                            })
                            .catch(function (error) {
                                //self.hideLoader();
                                self.catchHandler(error, function () {});
                            });

                }
            },
            forwardMessage: function() {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if(self.radioBtnId > 0) {

                    var fields = {
                        chatOf: segments[3],
                        forwardTo: self.radioBtnId,
                        fromName: self.userName,
                        section: self.sections,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    HTTP.post("forward-to-user", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    $('#basicModal').modal('hide');
                                    //console.log($('#basicModal')[0]);
                                    /* $('#basicModal')[0].hidden = true;
                                    $('.modal-backdrop').remove(); */
                                    /* self.loadCustomer();
                                    self.chatWindow = false;
                                    self.clickChatFlag = false; */
                                    self.backChatList();
                                }
                            })
                            .catch(function (error) {
                                $('#basicModal').modal('hide');
                                self.catchHandler(error, function () {});
                            });
                } else {
                    alert("Please Select any One User!");
                }
                
            },
            searchAPI:function(flag = null) {

                var self = this;
                var serachURL = (self.searchTab == 'user') ? 'list-user' : 'interacted-customers'

                if(flag == 'forwardChat') {
                    serachURL = 'list-user';
                }

                var fields = {
                    isUserList: (serachURL == 'list-user') ? 'chatUser' : 'chatCustomer',
                    isCustomerList : 'chatCustomer',
                    searchFlag: self.searchTab,
                    searchText: self.searchText,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post(serachURL, fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                if(self.searchTab == 'user') {
                                    self.userArray = response.data.content;
                                } else {
                                    if(flag == 'forwardChat') {
                                        self.userArray = response.data.content;
                                    } else {
                                        self.customerArray = response.data.content;
                                    }
                                    
                                }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });

            },
            loadCustomerDetails: function(id) {
                var self = this;
                var fields = {
                    'user_id': id
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post("get-details-by-id", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {

                            if (response.data.content != "") {
                                self.name = response.data.content.name;
                                self.email = response.data.content.email;
                                self.sections = response.data.content.sections;
                                self.role = response.data.content.role;
                            }
                        }
                        //self.hideLoader();
                    })
                    .catch(function (error) {
                        //self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            getMessageHistoryData: function(id) {
                var self = this;
                // self.messageArray = [];
                var fields = {
                    isFrom: '',
                    flag: '',
                    fromdate: '',
                    todate: '',
                    from_id: id,
                    to_id: self.logingId
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("get-messages", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if (response.data.content != "") {
                                    self.messageArray = response.data.content;

                                    /*setTimeout(function() {
                                        // $("body").animate({ scrollTop: $(".message-height").height() }, 1000);
                                        $(".message-height").animate({ 
                                            scrollTop: $(".message-height").prop("scrollHeight")
                                        }, 500);
                                    }, 200);*/
                                    setTimeout(function () {
                                        window.scrollTo(0,document.querySelector(".message-height").scrollHeight);
                                    }, 500);
                                }
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },
            sendMessage: function(flag) {

                var self = this;
                self.uuid = self.create_UUID();
                //self.messageArray = [];
                var error = false;
                self.message_text_error_msg = "";
                if(flag == 'EndChat') {
                    self.messageData = "Thank you for contacting us.";
                }
                if(self.messageData == '' || self.messageData == null) {
                    // Not neccessary to display message if messge input box is empty
                    // self.message_text_error_msg = "Message Field is Required.";
                    error = true;
                }

                if (!error) {
                    /*setTimeout(function() {
                        // $("body").animate({ scrollTop: $(".message-height").height() }, 1000);
                        $(".message-height").animate({
                            scrollTop: $(".message-height").prop("scrollHeight")
                        }, 100  );
                    }, 200);*/
                    // window.scrollTo(0,document.body.scrollHeight);
                    setTimeout(function () {
                        window.scrollTo(0,document.querySelector(".message-height").scrollHeight);
                    }, 500);
                    var fields = {
                        toId: self.toId,
                        fromId: self.logingId,
                        message: self.messageData,
                        fromName: self.userName,
                        flag: flag,
                        url: '',
                        uuid : self.uuid,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };

                    var date = new Date();
                    /* alert(self.timezone);
                    var sendDate = moment.tz(self.timezone);
                    sendDate = sendDate.format('MMM D, hh:mm A'); */
                    var sendDate = moment(date).format('MMM D, hh:mm A');
                    self.sendFromThisSide = true;
                    self.messageArray.push({
                        flag: flag,
                        message: self.messageData,
                        toId: self.toId,
                        fromName: self.username,
                        fromId: self.logingId,
                        created_date: sendDate,
                        url: "",
                        isFailed: false,
                        uuid : self.uuid,
                    });

                    self.messageData = "";
                    HTTP.post("send-message", fields, config)
                        .then(function (response) {
                            self.sendFromThisSide = false;
                            if (response.data.code == '200') {

                                if(flag == 'EndChat') {
                                    // alert("You have successfully end chat");
                                    self.$swal({
                                        title: 'Success ',
                                        text: "You have successfully end chat ",
                                        type: 'success ',
                                        confirmButtonText: 'Ok ',
                                        showLoaderOnConfirm: true
                                    })
                                }
                                // self.getMessageHistoryData();
                                self.messageData = '';
                            }

                            /* self.messageArray[self.messageArray.length - 1].isFailed = true;
                            console.log(self.messageArray[self.messageArray.length - 1].isFailed); */
                        })
                        .catch(function (error) {
                            self.sendFromThisSide = false;
                            if(error.response.code == 500) {
                                self.messageArray[self.messageArray.length - 1].isFailed = true;
                            }
                            if(error.response.code == 500) {
                                self.messageArray[self.messageArray.length - 1].isFailed = true;
                            }
                            // self.catchHandler(error, function () {});
                        });
                    /*  }
                 }); */
                }

            },
            changeReadCountValue() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    toId: segments[3],
                    fromId: self.logingId,
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("change-message-count", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                /* self.loadCustomer();
                                self.loadUser(); */
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },
            /*getTypeUserStatus() {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if(self.typeAPICallFlag) {

                    var fields = {
                        toId: segments[3],
                        fromId: self.logingId,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    HTTP.post("user-typing", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.typeAPICallFlag = false;
                                }
                            })
                            .catch(function (error) {
                                self.catchHandler(error, function () {});
                            });

                }

                setTimeout(function() {
                    self.typeAPICallFlag = true;
                    // self.isHideType = false;
                }, 3000);

            },*/
            broadCastChatDetails: function() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var pusherKey = 'message-broadcast-channle' + self.logingId;
                var eventKey = 'message-broadcast-event' + self.logingId;
                var channel = self.pusher.subscribe(pusherKey);

                channel.bind(eventKey, function(data) {
                    if(data.fromId == segments[3]) {
                        self.messageArray.push(data);
                        /*setTimeout(function() {
                            $(".message-height").animate({
                                scrollTop: $(".message-height").prop("scrollHeight")
                            }, 10);
                        }, 200);*/
                        setTimeout(function () {
                            window.scrollTo(0,document.querySelector(".message-height").scrollHeight);
                        }, 500);
                        self.$nextTick(() => {
                            setTimeout(function() {
                                self.changeReadCountValue();
                            }, 100);
                        });
                    } else {
                        if (self.checkUUID(self.messageArray, data.uuid) === false
                            && data.toId == self.toId) {
                            self.messageArray.push(data);
                            /*setTimeout(function() {
                                $(".message-height").animate({
                                    scrollTop: $(".message-height").prop("scrollHeight")
                                }, 10);
                            }, 200);*/
                            setTimeout(function () {
                                window.scrollTo(0,document.querySelector(".message-height").scrollHeight);
                            }, 500);
                        }
                    }

                    if(data.toId == self.logingId) {
                        self.$nextTick(() => {
                            self.listenNotification(data);
                        });
                    }
                });
            },

            listenNotification(messageData) {
                var self = this;
                if(messageData) {
                    var userAgent = navigator.userAgent;
                    var isWeb = false;
                    if(userAgent == 'vvg_chat'){
                        // var searchBar = document.getElementById("fNameMobile");
                    }else{
                        isWeb = true;
                    }

                    if (isWeb) {
                        if (!('Notification' in window)) {
                            console.log('Web Notification is not supported');
                            return;
                        }

                        Notification.requestPermission(permission => {

                            if(permission == 'granted') {
                                const title = messageData.fromName;
                                const options = {
                                    body:  messageData.message,
                                    icon: "/static/images/chat-icon.png",
                                    badge: "/static/images/chat-icon.png",
                                    data: {
                                        fromIdNotification : messageData.fromId
                                    }
                                };
                                var formIdNotification = messageData.fromId;
                                 navigator.serviceWorker.getRegistrations().then(
                                    function(registrations) {
                                        if(registrations.length==0) {  
                                            //registration.unregister();
                                            navigator.serviceWorker.register('/static/js/serviceworker.js').then(registration => {
                                    // registration.showNotification(title, options, formIdNotification);
                                })

                                        }
                                        else
                                        {
                                            // registrations[0].showNotification(title, options, formIdNotification);
                                        }
                                });
                                //for reference
                                /*navigator.serviceWorker.register('/static/js/serviceworker.js').then(registration => {
                                    registration.showNotification(title, options, formIdNotification);
                                })*/

                            }
                        });
                    }
                    self.playSound();
                }
            },

            //play notification sound
            playSound() {
                // console.log("Play Sound Call");
                var aSound = document.createElement("audio");
                aSound.setAttribute("src", "/static/notification.mp3");
                aSound.play();
            },

            broadCastTypeMessageChatDetails: function() {

                var self = this;

                var pusherKey = 'user-typing-channel' + self.logingId;
                var eventKey = 'user-typing-event' + self.logingId;

                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {
                    // alert(data);
                    self.isHideType = true;
                    setTimeout(function() {
                        self.isHideType = false;
                    }, 3000);
                });

                channel.bind('pusher:subscription_succeeded', function() {
                    console.log("Success");
                });

                channel.bind('pusher:subscription_error', function(status) {
                    console.log("error" + status);
                });

                var state = self.pusher.connection.state;
                console.log(state);
                self.pusher.connection.bind('state_change', function(states) {
                    // states = {previous: 'oldState', current: 'newState'}
                    console.log(states);
                    //$('div#status').text("Channels current state is " + states.current);
                });
                console.log(state);
                console.log(self.pusher);

            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/ChatDetail.vue